import Feature14 from './Feature14'
export default Feature14
